import "./fold.css";
import ASSETS from "../../../../../app/config/assets";

const Fold = ({ type, code_status }) => {
  return (
    <div className="fold">
      <img
        src={
          type === "not-found"
            ? ASSETS?.icon_data_gif
            : ASSETS?.icon_unauthorized_png
        }
        alt="not found or unauthorize pages illustrations"
      />
      <h1>{code_status}</h1>
    </div>
  );
};

export default Fold;
